module.exports = __webpack_public_path__ + "static/media/trenitalia-mobile.58ad6b18.svg";